import { registerWebComponent } from "@/tools/register-wc";

/**
 * Initializes the application by setting up the mock server (if enabled)
 * and registering the web component. Must be called before rendering.
 */
export async function initialize() {
  // Conditionally import mock server
  if (import.meta.env.APP_USE_MOCK_SERVER === "true") {
    console.log("🔧 Mock server enabled");
    await import("@/services/mock-server");
  } else {
    console.log(
      "Mock server disabled - using real API:",
      import.meta.env.APP_API_URL || "http://localhost:8080",
    );
  }

  // Register web component after mock server is ready
  registerWebComponent();
}
